export const QUERY_TYPES = {
  FIND_ACCOUNT: 'FindAccount',
  FIND_PASSWORD: 'FindPassword',
} as const;

export type QueryType = typeof QUERY_TYPES[keyof typeof QUERY_TYPES];

export const UBL_OBJECT_IDS = {
  SELF_CERTIFICATION: 'self_certification',
  TEL_AUTHORIZATION: 'tel_authorization',
  EMAIL: 'email',
} as const;

export const NAVIGATION_TYPES = {
  FIND_EMAIL_SELECT: 'find_email_select',
  FIND_PASSWORD_SELECT: 'find_password_select',
} as const;

export const isValidQueryType = (type: unknown): type is QueryType => {
  return typeof type === 'string' && Object.values(QUERY_TYPES).includes(type as QueryType);
};